// extracted by mini-css-extract-plugin
export var container = "_ud-0";
export var table = "_ud-2";
export var tableWrapper = "_ud-1";